<template>
    <v-card :loading="loading">
        <v-card-title class="subtitle-1 font-weight-bold px-6">
           {{ translations.cardHeader[lang] }} 
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
                <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4 pb-1">
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.title[lang] }}:
                {{ campaign&&campaign.title&&campaign.title[lang] }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.startDate[lang] }}:
                {{ campaign&&campaign.start_date }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.endDate[lang] }}:
                {{ campaign&&campaign.end_date }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.link[lang] }}:
                {{ campaign&&campaign.link ? campaign.link : "-" }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.email[lang] }}:
                {{ campaign&&campaign.email&&campaign.email[lang] }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.push[lang] }}:
                {{ campaign&&campaign.push&&campaign.push[lang] }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.sms[lang] }}:
                {{ campaign&&campaign.sms&&campaign.sms[lang] }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.totalParticipants[lang] }}:
                {{ campaign&&campaign.total_participants}}
            </v-sheet>
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.notified[lang] + ' ' +  translations.email[lang] }}:
                {{ campaign&&campaign.notifications&&campaign.notifications.email }}
            </v-sheet>
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.notified[lang] + ' ' +  translations.push[lang] }}:
                {{ campaign&&campaign.notifications&&campaign.notifications.push }}
            </v-sheet>
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.notified[lang] + ' ' +  translations.sms[lang] }}:
                {{ campaign&&campaign.notifications&&campaign.notifications.sms }}
            </v-sheet>
            
        </v-card-text>
    </v-card>
</template>

<script>
import { mdiClose } from "@mdi/js";

import translations from "@/utils/translations/loyaltyPanel/campaigns/viewCampaigns";
import { mapState, mapGetters } from "vuex";

export default {
    name: "AdditionalInfo",

    mixins: [translations],

    data: () => ({
        icons: { mdiClose },
    }),

    computed: {
        ...mapState(["loading"]),

        lang() {
            return this.$route.params.lang;
        },
        ...mapGetters("loyaltyPanel/campaigns/viewCampaigns", ["campaign","campaigns","campaignss"]),

        // campaign() {
        //     return this.$store.state.loyaltyPanel.campaigns.viewCampaigns.campaign;
        // },
    }
};
</script>
